export const  emailObfuscator = (emilString: string): string =>  {
  const nameLength = emilString.split('@')[0].length
  const domain = emilString.split('@')[1]
  if (nameLength > 5) {
  return  emilString.split('@')[0].substring(0,5).concat(Array(nameLength-5).join('*')).concat('@').concat(domain)
  } 
  return  emilString.split('@')[0].substring(0,3).concat('****@').concat(domain)
}
